/** Styl komponenty select (bývalý dropdown) k tématu Erma */
export const SelectStyles = {
  borderColor: 'var(--erma-secondary-300)',
  background: 'var(--erma-primary-0)',
  paddingY: '.429rem',
  paddingX: '.429rem',
  borderRadius: 'var(--erma-border-radius-sm)',
  overlay: {
    borderColor: '#ccc',
    background: 'var(--erma-primary-0)'
  },
  option: {
    padding: '.429rem .857rem',
    focusBackground: 'var(--erma-secondary-100)',
    selected: {
      background: 'var(--erma-primary-500)',
      color: 'var(--erma-primary-0)',
      focus: {
        background: 'var(--erma-primary-500)',
        color: 'var(--erma-primary-0)'
      }
    }
  },
  dropdown: {
    width: '2.357rem'
  },
  list: {
    padding: '0.1rem',
    gap: '2px',
    header: {
      padding: '0.5rem 1.5rem 0.5rem 0.5rem'
    }
  }
};
